/**
 * Short user-facing DCF failure text (no stack traces / file paths).
 */
const formatDcfErrorMessage = (raw, fallback = 'DCF processing failed') => {
  if (raw == null) return ''
  let text = String(raw).replace(/\r\n/g, '\n').replace(/\s+/g, ' ').trim()
  if (!text) return fallback

  const lowered = text.toLowerCase()
  const markers = [
    'traceback (most recent call last)',
    'traceback (most recent call last):',
    'file "',
    "file '",
    'stacktrace',
    'stack trace',
  ]
  let cut = text.length
  markers.forEach(marker => {
    const idx = lowered.indexOf(marker)
    if (idx !== -1) cut = Math.min(cut, idx)
  })
  text = text.slice(0, cut).replace(/[\s:;-]+$/, '')

  if (text.length > 180) {
    const seps = ['. ', '; ', ' — ', ' - ']
    for (let i = 0; i < seps.length; i += 1) {
      const sep = seps[i]
      if (text.includes(sep)) {
        const head = text.split(sep)[0].trim()
        if (head.length >= 24) {
          text = head
          break
        }
      }
    }
  }

  if (!text) return fallback
  if (text.length > 500) return `${text.slice(0, 499).trim()}…`
  return text
}

export default formatDcfErrorMessage
